import { render, staticRenderFns } from "./CmgRewardsAchievementsHeader.vue?vue&type=template&id=46da4604&scoped=true&lang=pug&"
import script from "./cmg-rewards-achievements-header.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-achievements-header.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsAchievementsHeader.vue?vue&type=style&index=0&id=46da4604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da4604",
  null
  
)

export default component.exports